<template>
  <v-footer
    id="core-footer"
    absolute
    height="30"
    class="pa-1 pr-2"
  >
    <div class="footer-items">
      <span
        v-for="link in links"
        :key="link.name"
      >
        <a
          :href="link.Link"
          class="tertiary--text footer-links"
        >{{ link.name }}</a>
      </span>
    </div>
    <v-spacer />
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
        href="http://www.eliainteractive.com/?from=WorkTools"
        target="_blank"
        style="color: black !important"
      >Elia Interactive</a>
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
    ]
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
  background: rgba(255,255,255,0.95)
}
</style>
